export default "__VITE_ASSET__6dea34c5__"